import type { ProcessStepExecutionStatus } from '@/api/processStepsApi'

/**
 * A process step's status in words and colour. One map, read by the step on
 * its form and by My Work, so the two never name the same status differently.
 */
export const PROCESS_STEP_STATUS_META: Record<
  ProcessStepExecutionStatus,
  { label: string; chip: string; dot: string }
> = {
  ASSIGNED: { label: 'Assigned', chip: 'bg-gray-100 text-gray-600', dot: 'bg-gray-400' },
  STARTED: { label: 'Started', chip: 'bg-blue-50 text-blue-700', dot: 'bg-blue-500' },
  PENDING: { label: 'Pending', chip: 'bg-amber-50 text-amber-700', dot: 'bg-amber-500' },
  COMPLETED: { label: 'Completed', chip: 'bg-green-50 text-green-700', dot: 'bg-green-500' },
}
